"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "name": "berlin",
    "comment": "HF targeted for July 2020 following the Muir Glacier HF",
    "url": "https://eips.ethereum.org/EIPS/eip-2070",
    "status": "Final",
    "eips": [2565, 2929, 2718, 2930]
};
//# sourceMappingURL=berlin.js.map